/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Formsy from 'formsy-react';
import moment from 'moment';
import { FormsyCheckbox, FormsyText, FormsySelect } from 'formsy-material-ui/lib';
import MenuItem from 'material-ui/MenuItem';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { textFieldStyle, multiLineText, common, dropDownStyle } from '../../../theme/AllocateBaseTheme';
import ApiSelector from '../../../containers/common/selectors/selectorContainer';
import ApiNestedSelector from '../../../containers/common/selectors/nestedSelectorConatainer';
import ActivitiesSummary from '../../../containers/common/ActivitiesSummary/ActivitiesSummaryContainer';
import {
  teamsEndpoint,
  teamsOptionsForOrgUnitEndpoint,
  activitiesEndpoint,
  careTypes,
} from '../../../settings/constants';
import { refSetter } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import { getMaxCliniciansByActivities } from '../../../actions/entities/activities';
import { numOfDaysInA } from '../../../settings/other';

const locale = globals.getArea('treatments');
const errors = globals.getArea('error');
const styles = {
  checkboxesRow: { flexDirection: 'column', marginLeft: 4 },
  descriptionRow: { flexDirection: 'column' },
  descriptionValidations: { maxLength: 500 },
  description: { ...multiLineText.style, width: '100%' },
  checkboxWidth: { width: '60%' },
  radioButton: { marginBottom: '5px' },
  radioButtonGroup: { flexDirection: 'column', width: '250px', marginLeft: 0 },
};
export const selectionTypes = {
  onSite: 'OnSite',
  phoneCall: 'PhoneCall',
};

class TreatmentDetails extends React.Component {
  constructor(props) {
    super(props);
    const {
      treatmentDetails: { additionalClinician, orgUnitIds, teamIds, activitiesIds, weeklyRequestedDays },
      selectedCareType,
      actionType,
    } = this.props;
    const hasAdditionalClinicians = additionalClinician > 0;
    this.state = {
      validationErrors: {},
      newDescription: null,
      chars_left: 500,
      max_chars: 500,
      sumOfFactors: 0,
      isTeamsFieldValid: true,
      isActivitiesFieldValid: true,
      isWeeklyRequestedDaysValid: actionType === 'EDIT' ? weeklyRequestedDays !== null : true,
      showWarningWillAffectVisits: false,
      selectionType: selectedCareType,
      selectedOrgUnit: orgUnitIds && orgUnitIds[0],
      selectedTeam: teamIds && teamIds[0],
      selectedActivities: activitiesIds,
      hasAdditionalClinician: hasAdditionalClinicians,
      additionalClinician: hasAdditionalClinicians ? additionalClinician : 1,
      maxClinicianCount: 0,
      showMissingTeamWarning: false,
      weeklyRequestedDays,
    };
  }

  setRef = refSetter.bind(this);

  getActivityIds = activities => {
    const value = (activities ? this.activities.props.getValue() || [] : []).map(v =>
      typeof v === 'object' ? v.id : v,
    );
    return value;
  };

  getVaraincesIds = activities => {
    const value = (activities ? this.activities.props.getValue() || [] : [])
      .filter(v => v.innerId !== null && v.innerId !== 0)
      .map(v => v.innerId);
    return value;
  };

  getCharLeftValue = () => {
    return this.state.newDescription === null && this.props.description !== null
      ? this.state.max_chars - this.props.description.length
      : this.state.chars_left;
  };

  filterActivitiesByOrgUnit = (orgUnit, selectedActivities, treatmentDetails) => options => {
    if (!orgUnit) {
      return options;
    }

    const orgUnitId = orgUnit.id;
    const treatmentOrgUnit = treatmentDetails && treatmentDetails.orgUnitIds && treatmentDetails.orgUnitIds[0];
    const treatmentActivities = treatmentDetails && treatmentDetails.activitiesIds;
    const selectedIds = selectedActivities && selectedActivities.map(sa => sa.id);

    return options.filter(
      o =>
        o.orgUnitsIds.length === 0 ||
        o.orgUnitsIds.includes(orgUnitId) ||
        (selectedIds && selectedIds.includes(o.id)) ||
        (treatmentActivities && treatmentOrgUnit && treatmentOrgUnit.id === this.state.selectedOrgUnit.id),
    );
  };

  updateDescriptionValue = (event, value) => {
    this.setState({ newDescription: value });
    const charCount = event.target.value.length;
    const maxChar = this.state.max_chars;
    const charLength = maxChar - charCount;
    this.setState({ chars_left: charLength });
  };

  handleChange = ({ reviewDate }) => {
    let validationErrors = {};
    if (reviewDate && moment(reviewDate).isSameOrBefore(globals.now, 'day')) {
      validationErrors = {
        reviewDate: locale.getMsg('reviewMustBeInTheFuture'),
      };
    }
    this.setState({ validationErrors });
  };

  handleSubmit = value => {
    if (value.orgUnitIds === undefined) {
      this.setState({
        isTeamsFieldValid: false,
      });
    }
    if (value.activitiesContainer === undefined) {
      this.setState({
        isActivitiesFieldValid: false,
      });
    }
    if (value.weeklyRequestedDays === null) {
      this.setState({
        isWeeklyRequestedDaysValid: false,
      });
    }
  };

  handleOrgUnitChange = (event, key, value, option) => {
    const filteredActivities =
      this.state.selectedActivities &&
      this.state.selectedActivities.filter(a => a.orgUnitsIds.length === 0 || a.orgUnitsIds.some(id => id === value));

    this.setState({
      selectedTeam: null,
      isTeamsFieldValid: this.checkIfIsRequired(value),
      selectedOrgUnit: option,
      selectedActivities: filteredActivities,
    });
  };

  handleTeamChange = (event, key, value, option) => {
    this.setState({ selectedTeam: option });
  };

  handleActivitiesChange = (event, key, value) => {
    const ch = this.checkIfActivityListChanged(value, this.props.treatmentDetails.activitiesIds);
    this.setState({
      isActivitiesFieldValid: this.checkIfIsRequired(value),
      showWarningWillAffectVisits: this.props.hasBundledOrFutureAssignedInstances && ch,
      selectedActivities: value,
    });
    setTimeout(this.calculateMaxClinicians, 300);
  };

  handleWeeklyRequestedDaysChange = values => {
    this.setState({ weeklyRequestedDays: values, isWeeklyRequestedDaysValid: true });
  };

  checkIfIsRequired = value => {
    if (this.activities.props.isFormSubmitted()) {
      if (value && value.length) {
        return true;
      }
      return false;
    }
    return true;
  };

  checkIfActivityListChanged = (newActivities, oldActivities) => {
    if (oldActivities === undefined) return true;
    const newActivitiesIds = newActivities.map(x => x.id);
    return oldActivities.length !== newActivities.length || !oldActivities.every(x => newActivitiesIds.includes(x.id));
  };

  handleSelectionTypeSwitch = (event, value) => {
    this.setState({
      selectionType: value,
      hasAdditionalClinician: false,
    });
    this.props.handleCareTypeChange(value);
    delete this.activities;
  };

  maxCliniciansCallback = response => response && this.setState({ maxClinicianCount: response.maxClinicianCount });

  calculateMaxClinicians = () => {
    const jwtToken = this.props.jwtToken;
    const activityIds = this.getActivityIds(this.activities);

    if (activityIds.length === 0) {
      this.setState({ maxClinicianCount: 0 });
    } else {
      getMaxCliniciansByActivities(jwtToken, { ActivityIds: activityIds }, this.maxCliniciansCallback);
    }
  };

  handleAdditionalClinician = e => {
    if (this.state.selectionType !== selectionTypes.onSite) return;

    const hasAdditionalClinician = e.target.checked;
    this.setState({
      ...this.state,
      hasAdditionalClinician,
    });
    if (hasAdditionalClinician) {
      setTimeout(this.calculateMaxClinicians, 300);
    }
  };

  validateTeamName = value => {
    // eslint-disable-next-line no-unused-expressions
    value.orgUnitIds === undefined
      ? this.setState({ showMissingTeamWarning: true })
      : this.setState({ showMissingTeamWarning: false });
    return true;
  };

  render() {
    const {
      treatmentDetails,
      innerRef,
      setValidity,
      readOnly,
      description,
      isReset,
      actionType,
      selectedCareType,
      isImportedFromSystmOne,
      enableRecordingOfWeeklyRequestedDays,
      enableMappingOfTeams,
    } = this.props;
    const { communityMatron = false, emergencyUnscheduled = false } = treatmentDetails || {};
    const {
      validationErrors,
      newDescription,
      showWarningWillAffectVisits,
      selectionType,
      additionalClinician,
      hasAdditionalClinician,
      showMissingTeamWarning,
      selectedOrgUnit,
      selectedTeam,
      selectedActivities,
      weeklyRequestedDays,
    } = this.state;

    return (
      <Box>
        <Formsy.Form
          ref={innerRef}
          onValid={setValidity(true)}
          onInvalid={setValidity(false)}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
          validationErrors={validationErrors}
          className="tab-box"
        >
          <Box display="flex" flexDirection="column">
            <Box p={1} flexGrow={1}>
              <RadioButtonGroup
                className="row"
                style={styles.radioButtonGroup}
                name="selectionType"
                defaultSelected={selectionTypes.onSite}
                onChange={this.handleSelectionTypeSwitch}
                valueSelected={selectionType}
              >
                <RadioButton
                  value={selectionTypes.onSite}
                  label="On Site"
                  style={styles.radioButton}
                  disabled={readOnly || actionType === 'EDIT' || isImportedFromSystmOne}
                />
                <RadioButton
                  value={selectionTypes.phoneCall}
                  label="Phone Call"
                  style={styles.radioButton}
                  disabled={readOnly || actionType === 'EDIT' || isImportedFromSystmOne}
                />
              </RadioButtonGroup>
            </Box>
            <Box p={1} flexGrow={1} style={{ width: '50%' }}>
              <ApiSelector
                reduxIdentifier="teams"
                endpoint={teamsEndpoint}
                required
                floatingLabelText={`${locale.getMsg('orgUnits')}*`}
                floatingLabelStyle={common.floatingLabelStyle}
                floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
                floatingLabelFocusStyle={common.floatingLabelFocusStyle}
                underlineStyle={common.underlineStyle}
                inputStyle={textFieldStyle.inputStyle}
                name="orgUnitIds"
                isFetchRequired
                value={selectedOrgUnit}
                disabled={readOnly || isImportedFromSystmOne}
                errorText={!isReset && !this.state.isTeamsFieldValid && errors.getMsg('requiredFieldValidationMessage')}
                errorStyle={dropDownStyle.errorStyle}
                validations={
                  isImportedFromSystmOne ? { showMissingTeamWarning: value => this.validateTeamName(value) } : null
                }
                onChange={this.handleOrgUnitChange}
              />
            </Box>
            {enableMappingOfTeams && (
              <Box p={1} flexGrow={1} style={{ width: '50%' }}>
                <ApiSelector
                  endpoint={teamsOptionsForOrgUnitEndpoint}
                  floatingLabelText={locale.getMsg('teams')}
                  floatingLabelStyle={common.floatingLabelStyle}
                  floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
                  floatingLabelFocusStyle={common.floatingLabelFocusStyle}
                  underlineStyle={common.underlineStyle}
                  inputStyle={textFieldStyle.inputStyle}
                  name="teamIds"
                  isFetchRequired
                  value={selectedTeam}
                  clearable
                  disabled={readOnly || isImportedFromSystmOne}
                  callArgs={{
                    id: selectedOrgUnit ? selectedOrgUnit.id : null,
                  }}
                  onChange={this.handleTeamChange}
                />
              </Box>
            )}
            <Box p={1} flexGrow={1} style={{ width: '50%' }}>
              <ApiNestedSelector
                innerRef={this.setRef('activities')}
                reduxIdentifier="activities"
                endpoint={activitiesEndpoint}
                required
                multiple
                floatingLabelText={`${locale.getMsg('activities')}*`}
                name="activitiesContainer"
                isFetchRequired
                callArgs={{ visitType: selectionType }}
                value={selectedActivities}
                clearable
                disabled={readOnly || isImportedFromSystmOne}
                onChange={this.handleActivitiesChange}
                errorText={
                  !isReset && !this.state.isActivitiesFieldValid && errors.getMsg('requiredFieldValidationMessage')
                }
                errorStyle={dropDownStyle.errorStyle}
                shouldCompareNatural={false}
                filterOptions={this.filterActivitiesByOrgUnit(
                  selectedOrgUnit,
                  selectedActivities,
                  this.props.treatmentDetails,
                )}
              />
            </Box>
          </Box>
          <Box display="flex" flexDirection="column">
            <Box p={1} flexGrow={1}>
              <ActivitiesSummary
                activitiesIds={this.getActivityIds(this.activities)}
                activityVarianceIds={this.getVaraincesIds(this.activities)}
                callback={this.calculateMaxClinicians}
              />
            </Box>
            <Box p={1} flexGrow={1}>
              <Grid container>
                <Grid item xs={3}>
                  <FormsyCheckbox
                    name="communityMatron"
                    label={locale.getMsg('communityMatron')}
                    value={communityMatron}
                    disabled={readOnly || isImportedFromSystmOne}
                    style={styles.checkboxWidth}
                  />
                  <FormsyCheckbox
                    name="emergencyUnscheduled"
                    label={locale.getMsg('emergencyUnscheduled')}
                    value={emergencyUnscheduled}
                    disabled={readOnly || isImportedFromSystmOne}
                    style={styles.checkboxWidth}
                  />
                  <FormsyCheckbox
                    name="hasAdditionalClinician"
                    label={locale.getMsg('hasAdditionalClinician')}
                    onChange={this.handleAdditionalClinician}
                    value={hasAdditionalClinician}
                    disabled={readOnly || selectedCareType !== careTypes.onSite || isImportedFromSystmOne}
                    style={styles.checkboxWidth}
                  />
                </Grid>
                <Grid item xs={9}>
                  {hasAdditionalClinician && (
                    <React.Fragment>
                      <FormsySelect
                        name="additionalClinician"
                        onChange={(event, value) => this.setState({ ...this.state, additionalClinician: value })}
                        value={additionalClinician}
                        style={{ width: '75px' }}
                        floatingLabelStyle={common.floatingLabelStyle}
                        floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
                        floatingLabelFocusStyle={common.floatingLabelFocusStyle}
                        underlineStyle={common.underlineStyle}
                        inputStyle={textFieldStyle.inputStyle}
                      >
                        <MenuItem value={1} primaryText="1" />
                        <MenuItem value={2} primaryText="2" />
                        <MenuItem value={3} primaryText="3" />
                      </FormsySelect>
                      <div>
                        {locale.getMsg('totalClinicianCount', [
                          (this.state.maxClinicianCount + this.state.additionalClinician).toString(),
                        ])}
                      </div>
                    </React.Fragment>
                  )}
                </Grid>
              </Grid>
            </Box>
            {!isImportedFromSystmOne && enableRecordingOfWeeklyRequestedDays && (
              <Box display="flex">
                <Box p={1} flexGrow={1} style={{ maxWidth: '20%' }}>
                  <FormsySelect
                    name="weeklyRequestedDays"
                    floatingLabelText={`${locale.getMsg('weeklyRequestedDays')}*`}
                    onChange={(event, value) => this.handleWeeklyRequestedDaysChange(value)}
                    value={weeklyRequestedDays}
                    disabled={readOnly}
                    floatingLabelStyle={common.floatingLabelStyle}
                    floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
                    floatingLabelFocusStyle={common.floatingLabelFocusStyle}
                    underlineStyle={common.underlineStyle}
                    style={dropDownStyle.style}
                    iconStyle={dropDownStyle.iconStyle}
                    labelStyle={dropDownStyle.labelStyle}
                    menuStyle={dropDownStyle.menuStyle}
                    required
                    validations="isRequired"
                    errorText={
                      !this.state.isWeeklyRequestedDaysValid && errors.getMsg('requiredFieldValidationMessage')
                    }
                    errorStyle={dropDownStyle.errorStyle}
                  >
                    {Array.from({ length: numOfDaysInA.week }, (_, i) => i + 1).map(value => (
                      <MenuItem key={`weeklyRequestedDaysOption${value}`} value={value} primaryText={value} />
                    ))}
                  </FormsySelect>
                </Box>
                <Box p={1} flexGrow={1} style={{ width: '33.3%' }}>
                  <div className="extra-info" style={{ paddingTop: '13px' }}>
                    {locale.getMsg('days')}
                  </div>
                </Box>
              </Box>
            )}

            <Box p={1} flexGrow={1} style={{ width: '50%' }}>
              <Typography variant="h6" gutterBottom>
                {locale.getMsg('treatmentDescription')}
              </Typography>
              <div style={styles.descriptionRow}>
                <FormsyText
                  multiLine
                  fullWidth
                  rows={6}
                  rowsMax={12}
                  className="formsytext-css"
                  validations={styles.descriptionValidations}
                  floatingLabelStyle={textFieldStyle.floatingLabelStyle}
                  floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
                  validationColor={textFieldStyle.validationColor}
                  style={styles.description}
                  inputStyle={multiLineText.inputStyle}
                  underlineStyle={multiLineText.underlineStyle}
                  underlineFocusStyle={multiLineText.underlineFocusStyle}
                  name="description"
                  value={newDescription === null ? description : newDescription}
                  onChange={this.updateDescriptionValue}
                  maxLength={this.state.max_chars}
                  disabled={isImportedFromSystmOne}
                />
                <Typography variant="subtitle2">You have {this.getCharLeftValue()} characters left.</Typography>
              </div>
            </Box>
          </Box>
        </Formsy.Form>
        <Box p={1} flexGrow={1}>
          {showWarningWillAffectVisits && (
            <div className="row" style={{ marginLeft: '8px', color: '#e84c3d' }}>
              <p>
                * {locale.getMsg('willAffectAssignedVisits')} {locale.getMsg('savingWillUnassign')}
              </p>
            </div>
          )}
        </Box>
        <Box p={1} flexGrow={1}>
          {showMissingTeamWarning && (
            <div className="row" style={{ marginLeft: '8px', color: '#e84c3d' }}>
              <p>{locale.getMsg('missingTeamWarning', [treatmentDetails.unmappedProviderTeam || ''])}</p>
            </div>
          )}
        </Box>
      </Box>
    );
  }
}

TreatmentDetails.defaultProps = {
  onFieldsUpdate: () => {},
  setValidity: () => {},
  innerRef: () => {},
  readOnly: false,
  description: '',
  hasBundledOrFutureAssignedInstances: false,
};

TreatmentDetails.propTypes = {
  treatmentDetails: PropTypes.shape({
    isValid: PropTypes.bool,
    orgUnitIds: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
    activitiesIds: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
    communityMatron: PropTypes.bool,
    emergencyUnscheduled: PropTypes.bool,
    details: PropTypes.string,
  }).isRequired,
  innerRef: PropTypes.func,
  setValidity: PropTypes.func,
  readOnly: PropTypes.bool,
  description: PropTypes.string,
  isReset: PropTypes.bool.isRequired,
  hasBundledOrFutureAssignedInstances: PropTypes.bool,
};

export default TreatmentDetails;
